import Header from '../Components/Header';
import Footer from '../Components/Footer';


function Terms() {
  return (
    <div >

      <Header />
    

      <div className='container main-contant terms-content'>
        <div className='inner-page-container'>
          <h1 className='page-title'>Terms and Conditions</h1>
          <div className='row'>


            <div className='col-md-12'>
              <p>Welcome to Aadikaash International. These Terms and Conditions (“Terms”) govern your use of our website https://aadikaash.com and participation in any of our exhibitions or related services.</p>
              <p>By accessing or using this website and/or registering for an event organized by Aadikaash International, you agree to comply with and be bound by these Terms. If you do not agree, please do not use the website or our services.</p>
              <h2>Definitions</h2>
              <ul>
                <li>“Organizer” refers to Aadikaash International.</li>
                <li>“User”, “You”, or “Participant” refers to any individual, company, or entity accessing the website or registering for events.</li>
                <li>“Event” means any trade show, exhibition, or expo organized by Aadikaash International.</li>
              </ul>

              <h2>Use of the Website</h2>
              <ul>
                <li>You must be at least 18 years old to use this website.</li>
                <li>You agree not to misuse the website, engage in illegal activity, or upload harmful content.</li>
                <li>All information submitted (e.g., registration details, exhibitor profiles) must be accurate and current.</li>
              </ul>

              <h2>Event Registration & Participation</h2>
              <ul>
                <li>Registrations are subject to approval by the Organizer.</li>
                <li>Aadikaash International reserves the right to deny entry to any individual or company without notice or explanation.</li>
                <li>Once confirmed, participation is non-transferable without prior written permission.</li>
              </ul>

              <h2>Event Registration & Participation</h2>
              <ul>
                <li>Registrations are subject to approval by the Organizer.</li>
                <li>Aadikaash International reserves the right to deny entry to any individual or company without notice or explanation.</li>
                <li>Once confirmed, participation is non-transferable without prior written permission.</li>
              </ul>

              <h2>Refund Policy</h2>
              <p>Refund Eligibility:</p>
              <ul>
                <li>If the event is cancelled or rescheduled by the organizer amount will be credited within 15 days (Subjected to approval by the ISJS Team)</li>              
              </ul>
              <p>Non-Refundable Conditions:</p>
              <ul>
                <li>Refunds will not be issued for any no-shows, partial attendance, or last-minute cancellations</li>
                <li>Entry passes once issued are non-transferable and non-refundable unless otherwise stated.</li>
              </ul>
            

              <h2>Privacy</h2>
              <p>Your use of the site and participation in our events is also governed by our <a href="https://aadikaash.com/privacy-policy" target="_blank">Privacy Policy</a>.
                We may use your contact information to send event updates, promotional materials, or exhibitor communications.</p>

              <h2>Limitation of Liability</h2>
              <p>Aadikaash International shall not be held liable for:</p>
              <ul>
                <li>Any loss, damage, or injury at events or while using the website.</li>
                <li>Technical failures, third-party misconduct, or inaccuracies in posted content.</li>
              </ul>

              <h2>Changes to Terms</h2>
              <p>We may update these Terms from time to time without notice. Continued use of the website or participation in events constitutes acceptance of the revised Terms.</p>

              <h2>Governing Law</h2>
              <p>These Terms are governed by the laws of India. Any disputes will be handled in the jurisdiction of Delhi, India.</p>

              <h2>Consent</h2>
<p>By accessing or using our website and services, you confirm that you have read, understood, and agreed to be bound by these <a href="https://aadikaash.com/terms-and-condition">Terms & Conditions</a>. If you do not agree, please do not use our website.</p>


              

            </div>


          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Terms;
